define(function (require) {
    "use strict";

    var Backbone = require('backbone');
    var _ = require('underscore');

    var GALLERY_ITEM_TYPES = {
        ITEM: 1,
        NEW: 2,
        LINK: 3,
        HTML: 4,
        TAGLET: 5,
        EXTERNAL: 6
    };

    var GalleryItemModel = Backbone.Model.extend({
        defaults : {
            key: "",
            name: "",
            description: "",
            backgroundImage:"",
            type: GALLERY_ITEM_TYPES.ITEM,
            isEditable: false, // not editable by default,
            isViewable: false, //  not  viewable by default,
            isDuplicatable: false, // not duplicatable by default,
            isSelectable: true
        },

        isTypeNew: function() {
            return this.get("type") === GALLERY_ITEM_TYPES.NEW;
        },

        isTypeLink: function() {
            return this.get("type") === GALLERY_ITEM_TYPES.LINK;
        },

        isTypeCustomHtml: function() {
            return this.get("type") === GALLERY_ITEM_TYPES.HTML;
        },

        isTypeTaglet: function() {
            return this.get("type") === GALLERY_ITEM_TYPES.TAGLET;
        },

        isTypeExternal: function() {
            return this.get("type") === GALLERY_ITEM_TYPES.EXTERNAL;
        },

        isRegularType: function(){
            return !(this.isTypeNew() || this.isTypeLink() || this.isTypeCustomHtml() || this.isTypeTaglet() || this.isTypeExternal());
        },

        isEditable: function() {
            return this.get("isEditable");
        },
        isDuplicatable: function() {
            return this.get("isDuplicatable");
        },
        isViewable: function() {
            return this.get("isViewable");
        },
        isSelectable: function() {
            return this.get("isSelectable");
        },
        isUserDefault: function() {
            return this.get("isUserDefault");
        },
        isApiBased: function() {
            return this.get("isApiBased");
        },
        isTimezoneBased: function() {
            return !_.isEmpty(this.get("timezoneStr"));
        },
        getKey: function(){
            return this.get("key");
        }
    });

    GalleryItemModel.TYPES = GALLERY_ITEM_TYPES;

    return GalleryItemModel;
});



